const Header = () => {
  return (
    <header>
      <div className="container">
        <h1>Mockups Portfolio</h1>
        <p>2D & 3D Design Work</p>
      </div>
    </header>
  )
}

export default Header
